import React from 'react';

/**
 * Stats secondaires compactes (points fiables uniquement).
 */
export default function ProgrammeStatsCard({ stats }) {
  if (!stats) return null;

  return (
    <section
      className="rounded-2xl border border-gray-200 bg-white p-4"
      data-testid="programme-stats-compact"
    >
      <h3 className="text-sm font-semibold text-gray-900 mb-3">Statistiques</h3>
      <div className="grid grid-cols-2 gap-3">
        <div className="rounded-xl bg-emerald-50/80 border border-emerald-100 px-3 py-3">
          <p className="text-xl font-bold text-emerald-800 tabular-nums leading-none">
            {Number(stats.pointsActifs).toLocaleString('fr-FR')}
          </p>
          <p className="text-[11px] text-emerald-900/70 mt-1.5 leading-snug">Points disponibles</p>
        </div>
        <div className="rounded-xl bg-purple-50/80 border border-purple-100 px-3 py-3">
          <p className="text-xl font-bold text-[#4A148C] tabular-nums leading-none">
            {Number(stats.pointsUtilises).toLocaleString('fr-FR')}
          </p>
          <p className="text-[11px] text-purple-900/70 mt-1.5 leading-snug">Points utilisés</p>
        </div>
      </div>
    </section>
  );
}
